import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./i18n";
import "./index.css";
// cache-bust: force vite dep re-optimization

createRoot(document.getElementById("root")!).render(<App />);
